import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue, FctValue16, isVariable } from '../../../../Fct/generics';
import { FaArrowUp } from 'react-icons/fa';
import { getAaveTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { A_TOKENS, LENDING_POOL_ADDRESSES } from '../constants';
export var Deposit = createPlugin({
    protocol: 'AAVE',
    type: 'ACTION',
    method: 'deposit',
    supportedContracts: LENDING_POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_lending_pool_v2' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveTokens({ chainId: chainId }), isPreview: true, icon: FaArrowUp }),
                    amount: new FctValue({ destination: 'wei_amount', isPreview: true }),
                    onBehalfOf: new FctAddress({}),
                    referralCode: new FctValue16({}),
                },
            },
            output: {},
        });
    },
    initParams: {
        methodParams: {
            referralCode: '0', // Aave has disabled referral codes, 0 by default
        },
    },
    requiredApprovals: function (params, _chainId, _walletAddress, _vaultAddress, _provider, _method, isEstimation) {
        var _a = params.methodParams, asset = _a.asset, amount = _a.amount, onBehalfOf = _a.onBehalfOf;
        var getValue = function () {
            if (isEstimation && isVariable(amount.value)) {
                return amount.estimatedValue;
            }
            return amount.value;
        };
        var value = getValue();
        if (!value)
            return [];
        return [
            {
                to: asset.value,
                from: onBehalfOf.value,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var _a;
        var to = params.to, _b = params.methodParams, amount = _b.amount, asset = _b.asset, onBehalfOf = _b.onBehalfOf;
        if (!asset.value || !to.value || !amount.value || !onBehalfOf.value || !vaultAddress)
            return [];
        if (typeof asset.value !== 'string' || typeof to.value !== 'string')
            return [];
        var aToken = (_a = A_TOKENS[chainId]) === null || _a === void 0 ? void 0 : _a.find(function (token) { return token.underlyingAssetAddress.toLowerCase() === asset.value.toLowerCase(); });
        if (!aToken)
            return [];
        return [
            {
                address: vaultAddress,
                toSpend: [
                    {
                        token: asset.value,
                        amount: amount.value,
                    },
                ],
                toReceive: [
                    {
                        token: aToken.aTokenAddress,
                        amount: amount.value,
                    },
                ],
            },
        ];
    },
});
